import { Injectable } from '@angular/core';

import { select, Store, Action } from '@ngrx/store';

import * as fromDrawerState from './drawer-state.reducer';
import * as DrawerStateSelectors from './drawer-state.selectors';
import * as DrawerStateActions from './drawer-state.actions';
import { DrawerParms, DrawerType } from '@care-portals/api-interfaces';

@Injectable()
export class DrawerStateFacade {

  popped$ = this.store.pipe(select(DrawerStateSelectors.getDrawerStatePopped));

  constructor(private store: Store<fromDrawerState.DrawerStatePartialState>) {}

  dispatch(action: Action) {
    this.store.dispatch(action);
  }

  openDrawer(params: DrawerParms) {
    this.dispatch(DrawerStateActions.openDrawer({ params }));
  }

  openDrawerSuccess(drawerName: DrawerType) {
    this.dispatch(
      DrawerStateActions.openDrawerSuccess({ drawerName })
    );
  }

  closeDrawer(params: DrawerParms) {
    this.dispatch(DrawerStateActions.closeDrawer({ params }));
  }
}
